import { installServerActionSkewFetchPatch } from './app/lib/serverActionSkew';

// Next 15.5.24 exposes UnrecognizedActionError via next/navigation. That only
// fires where a boundary or try/catch sees the throw. Login's useFormState
// rethrows into a boundary, but sign-out and other try/catch callers never
// surface a prompt. The fetch patch covers every Next-Action request and
// records which detector fired. error.tsx / global-error.tsx still use the
// first-party check when a boundary replaces this tree.
try {
	installServerActionSkewFetchPatch();
} catch (error) {
	console.error('[serverActionSkew] fetch patch not installed:', error);
}
